import React from "react";
import LoaderImg from "../assets/statics/ds-abreviado-logo.png";

import "../assets/css/Loader.css";
const Loader = (props) => {
  return (
    <>
      <div className="loader-wraper">
        <img src={LoaderImg} alt="Logo EscyelaDevRock" className="loader-img" />
      </div>
    </>
  );
};

export default Loader;
